<template>
  <div class="form-block">
    <div class="form-content form-approve">
      <div class="form-cell full-cell">
        <div class="form-label">退款金额</div>
        <div class="form-value ">
          <el-input onInput="this.value=this.value.replace(/^(0+)|[^\d]+/g,'')" v-model="form.actualMoney" maxlength="8" :disabled="disabled" placeholder="请输入退款金额"></el-input>
        </div>
      </div>
      <div class="form-cell full-cell">
        <div class="form-label ">描述</div>
        <div class="form-value ">
          <el-input v-model="form.remark"
                    type="textarea"
                    maxlength="200"
                    :autosize="{ minRows: 4}"
                    placeholder="请输入审核说明"></el-input>
        </div>
      </div>
      <div class="form-cell full-cell">
        <div class="form-label ">附件：</div>
        <div class="form-value ">
          <up-load-img ref="uploadImg"/>
        </div>
      </div>
      <div class="form-cell full-cell">
        <div class="form-label"></div>
        <div class="form-value">
          <el-button type="primary" @click="submit('2')">同意退款</el-button>
          <el-button v-if="!disabled" @click="submit('3')">驳回申请</el-button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import {RefundReasonState} from "../../service/enum";
  import {CacheService} from "../../service/common";
  import OrderService from "../../apis/orderService";
  import UpLoadImg from "./upload-img";

  export default {
    name: "refund-approve",
    components: {UpLoadImg},
    props: {
      refundInfo: {
        type: Object,
        default: () => {
        }
      }
    },
    computed: {
      disabled() {
        return this.refundInfo.reason == RefundReasonState.noReason;
      }
    },
    data() {
      return {
        form: {
          employeeId: CacheService.get("user").id,
          refundId: 0,
          actualMoney: 0,
          remark: "",
          attachList: []
        },
      }
    },
    mounted() {
      this.form.actualMoney = OrderService.toYuan(this.refundInfo.applyMoney);
      this.form.refundId = this.refundInfo.id;
    },
    methods: {
      checkForm() {
        if ((!this.form.actualMoney && this.form.actualMoney !== 0) || this.form.actualMoney < 0 || isNaN(this.form.actualMoney)) {
          throw `请输入正确的退款金额`
        }  else if (OrderService.toFen(this.form.actualMoney) > this.refundInfo.applyMoney) {
          throw `退款金额不能超过订单实付金额`
        } else if (this.form.actualMoney.toString().split(".")[1] && this.form.actualMoney.toString().split(".")[1].length > 2) {
          throw `退款金额最多两位小数 `
        }
      },
      async submit(refundState) {
        try {
          refundState == 2 && this.checkForm();
        } catch (e) {
          return this.$message.warning(e);
        }
        const attachList = this.$refs.uploadImg.saveUrls;
        const postData = {
          ...this.form,
          refundState,
          attachList,
          actualMoney: OrderService.toFen(this.form.actualMoney)
        }
        const res = await OrderService.approveRefund(postData);
        if (!res) return;
        this.$message.success(refundState == 2 ? "审核成功" : "驳回成功");
        this.$emit("approved");
      }
    }
  }
</script>

<style scoped lang="scss">
  .el-input--small {
    width: 406px;
  }

  .el-button {
    width: 193px;
    height: 50px;
    font-size: 16px;
    + .el-button {
      margin-left: 20px;
    }
  }
</style>